// extracted by mini-css-extract-plugin
module.exports = {"nameCell":"table-row_nameCell__1gCN7","hideOnMobile":"table-row_hideOnMobile__-r2Lw"};